module.exports = __webpack_public_path__ + "img/10.4ef05634.jpg";